import { Layout } from 'components/common/layout/Layout';
import { gql, useQuery } from 'urql';
import { CustomSEO } from '../../../components/common/layout/HeadMeta';
import { PartnersHeaderTabs } from '../../../components/partners-new/ind-partners/PartnersHeaderTabs';
import { PlayerRankCard } from '../../../components/partners-new/ind-partners/rankings/PlayerRankCard';
import { SchoolRankCard } from '../../../components/partners-new/ind-partners/rankings/SchoolRankCard';
import {
    OrgIhseaRankingDocument,
    OrgIhseaRankingQuery,
    OrgIhsenRankingsDocument,
    OrgIhsenRankingsQuery,
} from '../../../generated/spin-graphql';
import { UrqlSSGForPage } from '../../../server/utils/serverUtils/ssg.utils';

gql`
    query OrgIhsenRankings {
        espin_org_player(where: { org: { definition: { _eq: "ihsen_fed" } } }, order_by: { rank: asc }, limit: 20) {
            rank
            gpa
            grad_class
            game_rank
            username
            game {
                name
                game_definition
            }
            school {
                display_name
                city
                state
            }
        }
        espin_org_school(where: { org: { definition: { _eq: "ihsen_fed" } } }, limit: 10, order_by: { rank: asc }) {
            display_name
            city
            state
            rank
            bio
            records {
                wins
                losses
                game {
                    game_definition
                    name
                }
            }
        }
    }
`;

export default function IhsenRank() {
    const title = 'IHSEN Rankings';
    const description =
        'IEN players and schools are ranked per competition success & other related factors as students compete for Indiana state esports championships & esports scholarships.';
    const seoOverride: CustomSEO = {
        title: title,
        description: description,
    };

    const [playersQueryResult] = useQuery<OrgIhsenRankingsQuery>({ query: OrgIhsenRankingsDocument });
    const players = playersQueryResult?.data?.espin_org_player ?? [];
    const schools = playersQueryResult?.data?.espin_org_school ?? [];

    return (
        <Layout seoOverride={seoOverride}>
            <PartnersHeaderTabs
                tabOneTitle={'General'}
                tabOneRoute={'/partners/ien'}
                tabTwoTitle={'Recruiting'}
                tabTwoRoute={'/partners/ien/recruiting'}
                tabThreeTitle={'Rankings'}
                tabThreeRoute={'/partners/ien/rankings'}
                imgUrl={`/images/ind-partners/ihsen-logo.png`}
                imgWidth={205}
                imgHeight={226}
            />
            <div className="container">
                <PlayerRankCard rankings={players} title={`IEN Player Rankings`} />
                <SchoolRankCard rankings={schools} title={`IEN School Rankings`} />
            </div>
        </Layout>
    );
}

export async function getStaticProps(ctx) {
    return UrqlSSGForPage(OrgIhsenRankingsDocument);
}
